/**
 * This code handles the logic behind the "Report" button on the SlideView page. It is meant to allow
 * users to report content as inappropriate. At the time of writing this comment, the expected behavior
 * is that users may only report something once-- after that, they cannot change their mind in the back
 * end, so we disable the interaction in the front end as well.
 *
 * Additionally, there should be reasonable success/failure feedback given the one-shot nature of the
 * action (success notice via a toast, failure notice via red text on the reporting modal itself).
 */
(function(slideshare_object) {

  // DOM element constants
  var BUTTON_FLAG = '.action-flag .flag',
      BUTTON_ALREADY_FLAGGED = 'span.flagged',
      BUTTON_CONTAINER = 'a.action-flag',
      MODAL = '#report-slideshow-modal',
      MODAL_SUBMIT_BUTTON = '.flag-inappropriate .action-submit',
      MODAL_SELECT = '.flag-inappropriate form select',
      MODAL_ERROR_TEXT = '#flag-error-alert',
      TOAST_SUCCESS = '#slideview-report-notice',
      DROPDOWN_BUTTON = '.report-dropdown';

  /**
   * Sets button state for when a user has not yet flagged content.
   * NOTE: this method is also called for logged-out users!
   */
  function setButtonCanFlag() {
    $(BUTTON_ALREADY_FLAGGED).addClass('hide');
    $(BUTTON_FLAG).removeClass('hide');

    // Reveal button container now that the contents are loaded
    $(BUTTON_CONTAINER).removeClass('hide');
    $(DROPDOWN_BUTTON).removeClass('hide');
  }

  /**
   * Sets button state for when a user has already flagged some content as inappropriate.
   */
  function setButtonAlreadyFlagged() {
    $(BUTTON_ALREADY_FLAGGED).removeClass('hide');
    $(BUTTON_FLAG).addClass('hide');

    // Prevent default on the button container so that it won't pop users to the top of the page
    // (it is an anchor tag)
    $(BUTTON_CONTAINER).click(function(ev) {
      ev.preventDefault();
    });

    // Reveal button container now that the contents are loaded
    $(BUTTON_CONTAINER).removeClass('hide');
    $(DROPDOWN_BUTTON).addClass('hide');
  }

  // This method is called in the slideshare_object initializer
  slideshare_object.setup_flagging_interaction = function() {
    // Only allow user to flag if they haven't flagged before on this SS
    // flagged_value is passed in from the Rails controller. It will be
    // populated if the session user has already flagged this content.
    var hasFlagged = !!this.flagging.flagged_value;

    // Merge new functionality into slideshare_object.flagging, which is populated with
    // some data by the slideview#view action
    $.extend(this.flagging, {
      postUpdate: function() {
        var contentReportType = $(MODAL_SELECT).val();

        // Lock the modal submit while POSTing
        $(MODAL_SUBMIT_BUTTON).prop('disabled', true);

        $.post(slideshare_object.flagging.update_url, {
          ia_value: contentReportType,
          slideshow_id: slideshare_object.presentationId,
          source: 'slideviewer'
        }, function(returned_data) {
          log('POST Success: ' + returned_data);

          // Hide modal and display success notification
          $(MODAL).foundation('reveal', 'close');
          $(MODAL_ERROR_TEXT).addClass('hide');
          $(TOAST_SUCCESS).removeClass('hide');

          // Disable the report button
          $(BUTTON_CONTAINER).attr('disabled', true);
          setButtonAlreadyFlagged();

          // Scroll to top of page so users can see success toast
          $(window).scrollTop(0);
        }).fail(function(err) {
          log(err);

          // Show error text
          $(MODAL_ERROR_TEXT).removeClass('hide');
        }).always(function() {
          // Unlock the modal submit button after POSTing
          $(MODAL_SUBMIT_BUTTON).prop('disabled', false);
        });
      }
    });

    // Only enable the content report POST flow for logged-in users
    if (this.user.loggedin) {
      if (hasFlagged) {
        setButtonAlreadyFlagged();
      } else {
        // Unlock the report button
        $(BUTTON_CONTAINER).attr('disabled', false);

        // Hook up modal submit button event handler
        $(MODAL_SUBMIT_BUTTON).click(function(ev) {
          // Prevent the form from trying to POST something itself
          ev.stopPropagation();
          ev.preventDefault();

          slideshare_object.flagging.postUpdate();
        });

        // Initialize flag button state
        setButtonCanFlag();
      }
    } else {
      // Show the button for logged-out users as well
      setButtonCanFlag();
    }
  };
})(window.slideshare_object);
